import React from 'react';
import { StyleSheet } from 'react-native';
import { Container } from '@mui/system';
import { FooterContainer } from '../../components/ScreenContainer/FooterScreenContainer/FooterContainer';
import { FONT_ENUM } from '../../types/global/fonts.types';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { Spinner } from '@chakra-ui/react';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';

const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    header: {
        fontFamily: FONT_ENUM.BOLD_HEADER,
        fontSize: 20,
    },
    paragraphs: {
        fontFamily: FONT_ENUM.MEDIUM_TEXT,
    },
});

const PrivacyPolicy = () => {
    const { themeStyle } = useThemeContext();
    return (
        <Container disableGutters style={styles.container} maxWidth={false}>
            <FooterContainer noScroll>
                <DocViewer
                    prefetchMethod="GET"
                    config={{
                        header: {
                            disableHeader: true,
                            disableFileName: true,
                            retainURLParams: false,
                        },
                        csvDelimiter: ',', // "," as default,
                        pdfZoom: {
                            defaultZoom: 1.1, // 1 as default,
                            zoomJump: 0.2, // 0.1 as default,
                        },
                        pdfVerticalScrollByDefault: false, // false as default
                        loadingRenderer: {
                            overrideComponent: () => <Spinner h={20} w={20} />,
                        },
                    }}
                    documents={[
                        {
                            uri: 'https://thspian-seo-media.s3.us-east-2.amazonaws.com/legal/data_%26_privacy_2.24.24.docx',
                            fileType: 'docx',
                        },
                    ]}
                    pluginRenderers={DocViewerRenderers}
                    theme={{
                        primary: '#5296d8',
                        secondary: theme[themeStyle].tag_white,
                        tertiary: '#5296d899',
                        textPrimary: '#000',
                        textSecondary: '#5296d8',
                        textTertiary: '#00000099',
                        disableThemeScrollbar: false,
                    }}
                    style={{
                        height: '80vh',
                    }}
                />
            </FooterContainer>
        </Container>
    );
};

export { PrivacyPolicy };
